/* eslint-disable react/require-default-props */
import React from 'react';
import getFullNameWithTitle from '@medflex/utils/getFullNameWithTitle';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Badge, { KINDS, SIZES } from './Badge';

const MainRepresentativeBadge = ({ userDetails, href }) => {
  const { t } = useTranslation('components');
  const label = t('MainRepresentative.badgeTitle', { name: getFullNameWithTitle(userDetails) });

  return (
    <Badge size={SIZES.SMALL} kind={KINDS.SECONDARY} className="self-start">
      <div className="flex items-center text-sm font-normal space-x-1">
        <span className="whitespace-nowrap">
          {href ? (
            <Link to={href} className="hover:text-blue-500">
              {label}
            </Link>
          ) : (
            label
          )}
        </span>
      </div>
    </Badge>
  );
};

MainRepresentativeBadge.propTypes = {
  userDetails: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    dateOfBirth: PropTypes.string,
    gender: PropTypes.string,
  }).isRequired,
  href: PropTypes.string,
};

export default MainRepresentativeBadge;
